import { isSimpleIoSensorType, isValueMapSensorType } from "./models";
import type {
  RfidConfig,
  SensorConfig,
  SensorType,
  SimpleIoConfig,
  TemperatureConfig,
  ValueMapConfig,
  WeightConfig,
} from "./models";

/**
 * Every physical IO number a config occupies, across whichever channels its
 * `sensorType` defines -- used for cross-sensor IO-conflict checks (see
 * SensorCreateResult's `io-conflict` branch) and client-side duplicate
 * validation before submit. WEIGHT has one IO per `ios[]` entry; TEMPERATURE
 * has up to four (temperature/humidity/battery/dallasId), only some of
 * which apply depending on the entry's `probeType`; {@link SimpleIoSensorType},
 * RFID and {@link ValueMapSensorType} have exactly one per `ios[]` entry.
 */
export function sensorConfigIoNumbers(
  sensorType: SensorType,
  config: SensorConfig,
): readonly number[] {
  if (sensorType === "WEIGHT") {
    return (config as WeightConfig).ios.map((io) => io.io);
  }
  if (sensorType === "TEMPERATURE") {
    return (config as TemperatureConfig).ios.flatMap((io) => [
      io.temperature.io,
      ...(io.humidity === undefined ? [] : [io.humidity.io]),
      ...(io.battery === undefined ? [] : [io.battery.io]),
      ...(io.dallasId === undefined ? [] : [io.dallasId.io]),
    ]);
  }
  if (sensorType === "RFID") {
    return (config as RfidConfig).ios.map((io) => io.io);
  }
  if (isValueMapSensorType(sensorType)) {
    return (config as ValueMapConfig).ios.map((io) => io.io);
  }
  if (isSimpleIoSensorType(sensorType)) {
    return (config as SimpleIoConfig).ios.map((io) => io.io);
  }
  return [];
}
